<template>
	<b-modal
	ref="modal" 
	:size="size"
	centered
	@show="show"
	:modal-class="{
		'page-modal': !body
	}"
	v-bind="$attrs">

		<template v-slot:modal-header>
			<div class="w-100 d-flex align-items-center 
			justify-content-between">

				<span class="h5 fw-bold mb-0">
					{{title}}
				</span>

				<slot name="modal-header" />
			</div>
		</template>

		<slot />

		<template #modal-footer>
			
			<button 
			class="btn rounded-pill btn-outline-secondary" 
			@click="close">
				{{closeTitle}}
			</button>

			<loading-button 
			v-if="submit"
			theme="primary rounded-pill"
			:disabled="disabled"
			:loading="loading" 
			@click="$emit('submit')">
				{{submitTitle}}
			</loading-button>

		</template>

	</b-modal>
</template>

<script>

	export default {

		props: {

			title: {
				type: [String, Object],
				default: ''
			},

			submit: {
				type: Boolean,
				default: true
			},

			disabled: {
				type: Boolean,
				default: false
			},

			loading: {
				type: Boolean,
				default: false
			},

			body: {
				type: Boolean,
				default: true
			},

			preventClose: {
				type: Boolean,
				default: false
			},

			closeTitle: {
				type: String,
				default: function() {
					return this.$t('app.Close')
				}
			},

			submitTitle: {
				type: String,
				default: function() {
					return this.$t('app.Save')
				}
			},

			size: {
				type: String,
				default: "sm"
			}
		},

		methods: {

			show() {
				this.$store.dispatch('app/resetErrors')
				this.$emit('show')
			},

			open() {
				this.$refs.modal.show()
			},

			close() {

				if(!this.preventClose) 
				{
					this.$refs.modal.hide()
				}

				this.$emit('close')
			}
		}

	}

</script>


<style>
  .modal-backdrop {
    opacity: 0.65;
  }
</style>